import { render, staticRenderFns } from "./BracketsStartTournamentButton.vue?vue&type=template&id=7a3bff9a"
import script from "./BracketsStartTournamentButton.vue?vue&type=script&lang=js"
export * from "./BracketsStartTournamentButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports